import React from "react";
import { DeviceMobile, DeviceTablet, Laptop, Monitor, GooglePlayLogo } from "@phosphor-icons/react";
import Tr from "./Tr";
import { openPlayStoreRating } from "../lib/appLinks";

const DEVICES = [
  { icon: DeviceMobile, label: "Phone" },
  { icon: DeviceTablet, label: "Tablet" },
  { icon: Laptop, label: "Chromebook" },
  { icon: Monitor, label: "Desktop" },
];

export const CrossDeviceBanner = () => {
  return (
    <section className="mt-16 md:mt-24 hw-reveal" data-testid="cross-device-section">
      <div className="relative overflow-hidden rounded-[2rem] bg-forest text-cream px-6 py-10 md:px-12 md:py-14">
        <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-terracotta/20 blur-3xl" aria-hidden />
        <div className="relative lg:flex lg:items-center lg:justify-between lg:gap-12">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-terracotta font-semibold">
              <GooglePlayLogo size={14} weight="fill" /> <Tr>Now on Google Play</Tr>
            </span>
            <h2 className="font-heading text-3xl md:text-4xl leading-tight mt-3 font-medium">
              <Tr>Holy Words, on every screen you own.</Tr>
            </h2>
            <p className="text-cream/80 mt-3 text-sm md:text-base leading-relaxed">
              <Tr>Read, listen, and gather your faith community across your phone, tablet, Chromebook, and desktop — your place, your streak, and your lineup follow you everywhere.</Tr>
            </p>

            <div className="mt-7 grid grid-cols-4 gap-3 max-w-md">
              {DEVICES.map((d) => {
                const Icon = d.icon;
                return (
                  <div
                    key={d.label}
                    data-testid={`device-chip-${d.label.toLowerCase()}`}
                    className="flex flex-col items-center gap-2 rounded-2xl bg-cream/10 border border-cream/15 py-3 hover:bg-cream/15 transition-colors"
                  >
                    <Icon size={26} weight="duotone" className="text-cream" />
                    <span className="text-[10px] tracking-[0.15em] uppercase text-cream/70"><Tr>{d.label}</Tr></span>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="mt-8 lg:mt-0 shrink-0">
            <button
              onClick={openPlayStoreRating}
              data-testid="cross-device-playstore-btn"
              className="inline-flex items-center gap-3 pl-5 pr-7 h-14 rounded-full bg-cream text-forest font-bold text-base shadow-xl hover:scale-105 active:scale-95 transition-transform"
            >
              <GooglePlayLogo size={24} weight="fill" />
              <span className="text-left leading-tight">
                <span className="block text-[10px] tracking-[0.18em] uppercase text-forest/60 font-semibold"><Tr>Get it on</Tr></span>
                <span className="block text-lg font-heading">Google Play</span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CrossDeviceBanner;
